<template>
  <component
    :is="component"
    v-bind="componentProps"
    @click="$emit('click')"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
const instance = getCurrentInstance()

interface Props {
  link: string
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'click'): void
}>()
const attrs = useAttrs()

const match = computed(() => {
  return instance?.proxy?.$redirect?.match(props.link)
})

const path = computed(() => {
  return match.value?.path
})

const component = computed(() => {
  return match.value?.component
})

const linkProps = computed(() => {
  if (!path.value) {
    return {}
  }

  if (component.value === 'a') {
    return { href: path.value }
  }

  if (component.value === 'o-panel-link') {
    return { path: path.value }
  }

  return { to: path.value }
})

const forwardedAttrs = computed(() => {
  const {
    href,
    to,
    path,
    ...rest
  } = attrs as Record<string, any>

  return rest
})

const componentProps = computed(() => ({
  ...forwardedAttrs.value,
  ...linkProps.value,
}))
</script>
